<template>
    <div class="x-input-section">
        <el-input
            :clearable="true"
            :type="config.inputType || 'text'"
            :model-value="start" 
            :disabled="readonly || config.readonly" 
            :placeholder="config.placeholder" 
            :maxlength="config.maxlength || 100" 
            :suffix-icon="config.icon"
            @update:modelValue="(value, oldvalue)=> {start = value; $emit('update:modelValue', getModelValue(), modelValue)}"  
            style="width:46%;float: left;"
        ></el-input>
        <div style="width: 8%;text-align: center;float: left;">到</div>
        <el-input
            :clearable="true"
            :type="config.inputType || 'text'"
            :model-value="end" 
            :disabled="readonly || config.readonly" 
            :placeholder="config.placeholder" 
            :maxlength="config.maxlength || 100" 
            :suffix-icon="config.icon"
            @update:modelValue="(value, oldvalue)=> {end = value; $emit('update:modelValue', getModelValue(), modelValue)}" 
            style="width:46%"
        ></el-input>
    </div>
</template>
<script setup>
import { defineProps, ref, watch } from 'vue';

const props = defineProps({
    config: { default: null },
    readonly: { default: false },
    modelValue: { default: null },
    data: { default: null },
    field: { default: null },
})
defineEmits({
    'update:modelValue': null,
});

const start = ref(null);
const end = ref(null);

watch(()=> props.modelValue, (value)=> {
    start.value = getStart(value);
    end.value = getEnd(value);
})
const getModelValue = ()=> {
    return [start.value, end.value];
}

const getStart = (value)=> {
    return value ? value[0] : null;
}
const getEnd = (value)=> {
    return value ? value[1] : null;
}
</script>
<style>
.x-input-section{
width: 100%;
}
</style>
